import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'



const getDefaultStateForSystemSettings = () => {
  return {
    data:{},
    active_list:[],
    system_settings: [],
    is_created:"",
    is_updated:"",
    is_deleted:"",
    filter:
    {
      keyword:"",
      active_only:"1"
    },
  }
}

// state
const state = getDefaultStateForSystemSettings()

const getters = {

}

// mutations
const mutations = {
    FETCH(state, data){
      state.data = data
    },
    SET_IS_CREATED(state, data)
    {
      state.is_created = data
    },
    SET_IS_UPDATED(state, data)
    {
      state.is_updated = data
    },
    SET_IS_DELETED(state, data)
    {
      state.is_deleted = data
    },
    SET_FILTER(state, data){
        state.filter = data
    },
    SET_ACTIVE_LIST(state, data){
        state.active_list = data
    },
    FETCH_ALL(state, data){
        if(data)
        {
            // data.forEach(function (element) {
            //     element.is_customer_dispaly = (element.is_customer == 1) ? 'YES' : 'NO'
            //     element.is_vendor_dispaly = (element.is_vendor == 1) ? 'YES' : 'NO'
            //     element.is_employee_display = (element.is_employee == 1) ? 'YES' : 'NO'
            // });
            state.system_settings = data
        }

    },
    RESET_STATE_FOR_SYSTEM_SETTINGS (state) {
      Object.assign(state, getDefaultStateForSystemSettings())
    },
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
      commit("RESET_STATE_FOR_SYSTEM_SETTINGS")
    },
    getActiveList({ commit }, data) {
        return axios.post(apiRoutes['SYSTEM_SETTING_LIST'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('SET_ACTIVE_LIST', response.data.data)
              } else {
                commit('SET_ACTIVE_LIST', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
      },
    fetch({ commit }, data) {
      return axios.post(apiRoutes['SYSTEM_RETRIEVE'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH', response.data.data)
            } else {
              commit('FETCH', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
    quickSearch({ commit }, data) {
        return axios.post(apiRoutes['SYSTEM_QUICK_SEARCH'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH_ALL', response.data.data)
                commit('SET_FILTER', data)
              } 
              else 
              {
                commit('FETCH_ALL', [])
                commit('SET_FILTER', data)
              }
            })
            .catch(error => {
              if (error.response) {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    async create({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['SYSTEM_CREATE'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'System Setting (' + doc_number + ')' + " has been created!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  commit('SET_IS_CREATED', 1);
            }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
              commit('SET_IS_CREATED', 0);

            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
              commit('SET_IS_CREATED', 0);

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Creating Case Type")
              }
          });
    },
    async update({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['SYSTEM_UPDATE'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'System Setting (' + doc_number + ')' + " has been updated!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  commit('SET_IS_UPDATED', 1);

            }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }

                commit('SET_IS_UPDATED', 0);


            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application Error")
              }
          });
    },
    async delete({ commit, dispatch }, data) {
      await axios.post(apiRoutes['SYSTEM_SETTING_DELETE'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'Contact Category (' + doc_number + ')' + " has been deleted!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  commit('SET_IS_DELETED', 1);
            }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_DELETED', 0);


            }

          })
          .catch((error) => {

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Deleting Case Type")
              }
          });
    },

}

export {
    state,
    getters,
    actions,
    mutations
}
